import {ChangeDetectorRef, Component, HostListener, Inject, OnInit} from '@angular/core';
import {
  NEW_SESSION,
  NMDPHttpClientInterceptor,
  NmdpWidget,
  SESSION_CLOSED,
  SESSION_EXTENDED,
  SESSION_TIMEOUT
} from '@nmdp/nmdp-login';
import {LogoutService} from './logout/logout.service';
import {ConfigService} from './config/config.service';
import {catchError} from "rxjs/operators";
import {of} from "rxjs";

@Component({
  selector: 'my-app',
  template: `
  <nav-bar></nav-bar>
  <div *ngIf="!loginWidget.isLoggedIn()" id="okta-login-container"></div>
  <div *ngIf="loginWidget.isLoggedIn()">
    <home-component></home-component>
    <footer-component></footer-component>
  </div>
  `,
  providers: [LogoutService, ConfigService],
})
export class AppComponent implements OnInit {

  guest: boolean;
  loggedIn: boolean;
  tok: any = null;

  constructor(private readonly configService: ConfigService,
              public loginWidget: NmdpWidget,
              private readonly ref: ChangeDetectorRef,
              private readonly logoutService: LogoutService) {
  }

  ngOnInit() {
    /*
  * initialize the SEL
  * 1) set the DIV where to display the login form
  * 2) subscribe to SSO events
  * 3) enable the NMDP HTTP Interceptor
  * 4) call the sessionInfo() API to determine whether the app is logged in.  This
  *    will then cause the emission of SESSION_CLOSED event (not logged in) or a NEW_SESSION
  *    event (already logged in)
  */
    this.loginWidget.setWidgetLocation('#okta-login-container');
    this.loginWidget.onEvent.subscribe(this.processSELEvent.bind(this));
    // enable the NMDP HTTP interceptor
    NMDPHttpClientInterceptor.enable(this.processTimeout.bind(this)); // process timeouts via subscribing to SESSION_TIMEOUT event
    // call the sessionInfo() API
    this.loginWidget.sessionInfo(); //get session info
  };

  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange() {
    if (document.hidden) {
      //tab is not active
    }else{
      //tab is active
      if(this.tok != localStorage.getItem('oktaSession') && this.loginWidget.isLoggedIn()) {
          console.log("session has been modified");
          this.loginWidget.refreshAccessToken((rawtoken: any) => {
          this.tok = localStorage.getItem('oktaSession');
        });
      }
    }
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
      if( this.loginWidget.isLoggedIn()){
        this.loginWidget.markActive();
    }
  }

  // return a reference to the SEL
  getLoginWidget() {
    return this.loginWidget;
  }

  processTimeout( timeoutType:any ) {
    //just got a timeout – log it??
    console.log('just got a timeout of type: ' + timeoutType);
    const oldSubject = this.loginWidget.subject;
    // check to see if session is active
    this.loginWidget.getNewToken( (rawtoken:any) =>  {

      // this will display a new login screen if needed
      if ( oldSubject == null || this.loginWidget.subject !== oldSubject) {
        // clean out any old data from previous usage
        // as a different user may be at the browser
        //<< DO SOMETHING – REINITIALIZE APP, a different user has logged in >>
        console.log("Load Guest")
      }
    //<< Do post timeout event processing (refresh screen?) >>
    }).pipe(catchError((error) => {
      this.ref.detectChanges();
      return of(null);
    }));

  }

  logout(): any {
    this.logoutService.userLogout()
      .then(logoutResponse => {
        this.loginWidget.signout( (err:any)=>{
          // at this point, there is no widget loaded.
          this.guest=false;
          this.loggedIn=false
          this.ref.detectChanges();
          this.ngOnInit();
        });
      });
  }


  login(): any {
    this.logout();  //will remove Guest login credentials
  }
  /*
    * this function is executed when any SEL event is emitted
    * It manages the event -- adds it to the list of events
    *  and then acts accordingly.
    * for the SESSION_CLOSED event, it displays the SEL for a new login
    * for the NEW_SESSION event, it processes displays the token, Most apps will not need to do this , but may need to do something else.
    * for the SESSION_EXTENDED event, it makes sure that time left in session field is correctly displayed )
    * for the SESSION_TIMEOUT event, it calls the processTimeout function.
    */
  processSELEvent( event:any ) {

    switch(event.type){
      case SESSION_CLOSED:
        // detect the changes -- needed so that the login form will be displayed
        this.ref.detectChanges();
        // show the login.  Can also use this.nmdpWidget.getNewToken(), but that makes an extra call to Okta...
        this.loginWidget.showLogin();
        break;

      case NEW_SESSION:
        this.loginWidget.getAccessToken().then(token => {
          this.tok = localStorage.getItem('oktaSession');
          console.log(this.tok);
          this.guest = this.loginWidget.isGuestUser();
          this.loggedIn = this.loginWidget.isLoggedIn();
        }).finally(() => {
          this.ref.detectChanges();
        });
        break;

      case SESSION_EXTENDED:
        // No need to do anything with this event.
        // This event would need to be handled if there were a count-down timer or other time-limited
        // logic that needed to know when the SSO Session was extended
        break;

      case SESSION_TIMEOUT:
        // this.loginWidget.signout( (err:any)=>{
        //   // at this point, there is no widget loaded.
        //   this.guest=false;
        //   this.loggedIn=false
        //   // this.ref.detectChanges();
        //   // this.ngOnInit();
        // });
         this.processTimeout(event.data);
        break;

    }
  }
}
